module.exports = __webpack_public_path__ + "img/sf3.d2d23d9c.png";